import { Typography } from '@mui/material';
import React from 'react';

const SimUnorderedList = ({ title = '', list = [] }) => {
	return (
		<>
			{title && <Typography textAlign={'justify'}>{title}</Typography>}
			<ul>
				{list.map((item, idx) => (
					<li key={idx}>
						<Typography textAlign={'justify'}>{item}</Typography>
					</li>
				))}
			</ul>
		</>
	);
};

export default SimUnorderedList;
